import {
  useGetLastIndividualCompQuery,
  useGetLastTeamCompQuery,
  useGetUpcomingEventsQuery,
  useGetCommitteeMembersQuery,
  useGetMemberSummaryQuery,
} from '../state/api';
import { selectMemberEntities } from '../state/entitySelectors';
import { useAppSelector } from '../hooks/reduxHooks';
import { createMemberLookupFromArray } from '../utils/committee';
import { HomePage } from './home-page';

const HomePageContainer = () => {
  // RTK Query hooks automatically handle fetching, caching, and state management
  const { data: lastIndividualComp } = useGetLastIndividualCompQuery();
  const { data: lastTeamComp } = useGetLastTeamCompQuery();
  const { data: upcomingEvents = [] } = useGetUpcomingEventsQuery();
  const { data: committeeMembers = [] } = useGetCommitteeMembersQuery();
  useGetMemberSummaryQuery();

  // Extract IDs from the response data
  // Both APIs return objects with 'id' field (lowercase)
  const lastIndividualCompId = lastIndividualComp?.id;
  const lastTeamCompId = lastTeamComp?.id;

  // Use entity selector for O(1) member lookups
  const memberEntities = useAppSelector(selectMemberEntities);
  const memberLookup = createMemberLookupFromArray(Object.values(memberEntities));

  return (
    <HomePage
      lastIndividualCompId={lastIndividualCompId}
      lastTeamCompId={lastTeamCompId}
      upcomingEvents={upcomingEvents}
      committeeMembers={committeeMembers}
      memberLookup={memberLookup}
    />
  );
};

export default HomePageContainer;
